import { combineReducers } from 'redux';
import {
  TOGGLE_FILTER_MENU,
  SET_VIEWED_TAB,
  INFO_BUTTON_CLICKED,
  ZOOM_BUTTON_CLICKED,
  APPLY_FABRIC_FILTER,
  CLEAN_FABRIC_FILTER,
  APPLY_DETAIL_PRESET,
  FABRIC_PREVIEW_SETTED,
  UPDATE_PRODUCT_BY_DETAIL,
  SET_DETAIL_VIEWED_TAB,
  CATALOG_PRODUCT_OPENED,
} from '../../constants/actionTypes';


const isFontSelectorOpened = (state = false, action) => {
  if (action.payload && action.payload.name !== 'embroideryText') {
    return state;
  }
  if (action.type == '@@redux-form/REGISTER_FIELD') {
    return true;
  }

  if (action.type == '@@redux-form/UNREGISTER_FIELD') {
    return false;
  }
  return state;
}

const selectedTab = (state = 0, action) => {
  if (action.type == SET_VIEWED_TAB) {
    return action.payload;
  }
  return state;
}

const filterMenuOpened = (state = false, action) => {
  if (action.type == TOGGLE_FILTER_MENU) {
    return !state;
  }
  return state;
}

const activeDetailsPreset = (state = '', { type, preset }) => {
  switch (type) {
    case APPLY_DETAIL_PRESET:
      return preset;
    default:
      return state;
  }
}

const selectedDetailTab = (state = '', action) => {
  if (action.type === SET_VIEWED_TAB) {
    return '';
  }
  if (action.type === SET_DETAIL_VIEWED_TAB) {
    return action.payload
  }
  return state;
}

const activeFabricFilters = (state = {}, action) => {
  const { filterType, filterValue, checked } = action;

  switch (action.type) {
    case APPLY_FABRIC_FILTER: {
      if (checked) {
        return {
          ...state,
          [filterType]: {
            ...state[filterType],
            [filterValue]: checked
          }
        }
      } else {
        if (!state[filterType]) {
          return state;
        }

        const nextState = { ...state }
        delete nextState[filterType][filterValue]
        if (Object.keys(nextState[filterType]).length === 0) {
          delete nextState[filterType]
        }

        return nextState
      }
    }

    case CLEAN_FABRIC_FILTER: {
      if (!state[filterType]) {
        return state;
      }
      const nextState = { ...state }
      delete nextState[filterType]

      return nextState
    }

    default:
      return state;
  }
}

const fabricSearchQuery = (state = '', { type, payload }) => {
  if (type === 'INIT_SEARCH') {
    return payload
  }
  return state;
}

const fabricInfoOpened = (state = false, action) => {
  if (action.type == INFO_BUTTON_CLICKED) {
    return action.payload;
  }
  return state;
}

const fabricPreview = (state = false, action) => {
  if (action.type == FABRIC_PREVIEW_SETTED) {
    return action.fabric;
  }
  return state;
}

const zoomMode = (state = false, action) => {
  if (action.type == ZOOM_BUTTON_CLICKED) {
    return action.payload;
  }
  return state;
}

const sizesSnackOpened = (state = false, action) => {
  if (action.type == 'TOGGLE_SIZE_SNACK') {
    return action.state;
  }
  return state;
}


const builderPage = (state = 1, action) => {
  if (action.type == 'SET_BUILDER_PAGE') {
    return action.payload;
  }
  return state;
}

const imagesLoading = (state = false, action) => {
  if (action.type == 'IMAGES_LOADING') {
    return action.payload;
  }
  return state;
}

const selectedSizeAttr = (state = '', action) => {
  if (action.type == 'SIZE_ATTR_SELECTED') {
    return action.payload;
  }
  return state;
}

const priceChanged = (state = '', action) => {
  return state;
}

const catalogProductOpened = (state = false, action) => {
  if (action.type == CATALOG_PRODUCT_OPENED) {
    return !state;
  }
  return state;
}

const modalState = (state = {}, action) => {
  if (action.type == 'TOGGLE_MODAL') {
    return {
      ...state,
      [action.id]: !state[action.id]
    }
  }
  return state;
}

const isMobile = (state = false, { type, payload }) => {
  if (type === 'SCREEN_RESIZE') {
    return payload < 768;
  }
  return state;
}

const setParamsError = (state = false, action) => {
  if (action.type == 'SET_PARAMS_ERROR') {
    return action.payload;
  }
  return state;
}

export default combineReducers({
  selectedTab,
  fabricInfoOpened,
  fabricSearchQuery,
  fabricPreview,
  activeFabricFilters,
  activeDetailsPreset,
  filterMenuOpened,
  zoomMode,
  imagesLoading,
  sizesSnackOpened,
  builderPage,
  selectedSizeAttr,
  priceChanged,
  isFontSelectorOpened,
  selectedDetailTab,
  catalogProductOpened,
  modalState,
  isMobile,
  setParamsError
});
